import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ScreenSizeService, ViewMode } from '../../../services/screen-size';

@Component({
  selector: 'now-wbsuche-lib-bearbeiten-button',
  templateUrl: './bearbeiten-button.component.html',
  imports: [AsyncPipe]
})
export class BearbeitenButtonComponent {
  private readonly screenSizeService = inject(ScreenSizeService);

  smallButton$ = this.screenSizeService.rangeTo$(ViewMode.PHABLET);
  @Input({ required: true }) label = '';

  @Output()
  resetEmitted = new EventEmitter<void>();
}
